import { render, staticRenderFns } from "./AutomatedEmails.vue?vue&type=template&id=5607df88&scoped=true"
import script from "./AutomatedEmails.vue?vue&type=script&lang=js"
export * from "./AutomatedEmails.vue?vue&type=script&lang=js"
import style0 from "./AutomatedEmails.vue?vue&type=style&index=0&id=5607df88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5607df88",
  null
  
)

export default component.exports